// action types
export const SEND_LOG = 'SEND_LOG';

// action creators
export const sendLog = ({ product, title, detail, severity }) => ({
  type: SEND_LOG,
  payload: { product, title, detail, severity },
});
